import { AuthenticationService } from './../../services/user/authentication.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute} from '@angular/router';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-mobilelogin',
  templateUrl: './mobilelogin.component.html',
  styleUrls: ['./mobilelogin.component.css']
})
export class MobileloginComponent implements OnInit {
  UserName:any;
  Password:any;
  MPGCode:any;
  ErrorMsg:any;
  LoginType:any;
  constructor(private activatedRoute: ActivatedRoute,private formBuilder: FormBuilder,private globalHelper:GlobalHelper, private  authenticationService:AuthenticationService, private router:Router,private userService:UserService) { 
    this.ErrorMsg="";  
    this.globalHelper.App="PUBLIC";
    window.localStorage.clear();
    this.globalHelper.SiteMap=null;
    this.activatedRoute.queryParams.subscribe(params => {     
       this.MPGCode =  params['MPGCode'];
       this.LoginType =  params['LoginType'];
       this.VerifyMGPCode();
  });
  
  }
  VerifyMGPCode(){
    this.authenticationService.VerifyMGPCode(this.MPGCode).subscribe((data:any)=>{
      this.UserName=data.UserName;
      this.Password=data.Password;
      if(this.UserName!=null && this.Password!=null && data.Status){
          this.OnGetTokenMobile();
        }
      else{
        this.ErrorMsg="Your session has expired. Please re-payment ";
      }      
    });
  }

  OnGetTokenMobile(){
    this.authenticationService.UserAuthentication(this.UserName,this.Password).subscribe((data:any)=>{
       this.globalHelper.SetUserToken(data.access_token);   
       this.globalHelper.SetToken(data.LoginToken);            
      if(data.access_token!=null &&  this.globalHelper.GetLoginToken().UserTypeID==5 && this.LoginType=="P"){
       this.router.navigate(['/studentfeepayment']);
     } 
     else
     if(data.access_token!=null &&  this.globalHelper.GetLoginToken().UserTypeID==5 && this.LoginType=="REPORT"){
      this.router.navigate(['/studentacademics']);
    }
    else if(data.access_token!=null && this.LoginType=="W" && this.globalHelper.GetLoginToken().UserTypeID!=5){
        this.router.navigate(['/academicselection']);
    }
    else if(data.access_token!=null && this.LoginType=="W" && this.globalHelper.GetLoginToken().UserTypeID==5){
      this.router.navigate(['/dashboard']);
  }
     else{
      alert('Login  Error');
      }      
    });
 
   }
  ngOnInit() {
  }

}
